const { initialState } = window;
const { search } = initialState;

export default (state = search, action) => {
	switch (action.type) {
		case "SEARCH_SET_TIMER":
			console.log(action.payload);
			return Object.assign({}, state, {
				...state,
				timer: setTimeout(action.payload.function, action.payload.wait_time)
			});
		case "SEARCH_SET_VALUE":
			return Object.assign({}, state, {
				...state,
				value: action.payload.value
			});
		case "SEARCH_SET_RESULTS":
			return Object.assign({}, state, {
				...state,
				results: action.payload.results,
				hasResults: true
			});
		case "SEARCH_CLEAR":
			return Object.assign({}, state, {
				...state,
				value: "",
				visible: false
			});
		case "SEARCH_SET_VISIBLE_STATUS":
			return Object.assign({}, state, {
				...state,
				visible: action.payload.visible
			});
		case "SEARCH_SET_LOADING_STATUS":
			return Object.assign({}, state, {
				...state,
				loading: action.payload.loading
			});

		case "SEARCH_CLEARTIMEOUT":
			clearTimeout(state.timer);
			return state;
		default:
			return state;
	}
};
